import Vue from "vue";
import Router from "vue-router";

/* Base Layout */
import BaseLayout from "@/layout/BaseLayout.vue";

/* Page definitions */
import Homepage from "@/pages/Homepage.vue";
import NotFound from "@/pages/404.vue";
import Argumento from '@/pages/Argomenti.vue';
//import Search from '@/pages/Ricerca.vue';
import Search2 from '@/pages/Ricerca2.vue';

import Layout1 from '@/pages/Articolo.vue' //Articolo

/* import routers */
import programmaRoutes from '@/router/programme.js';
import specializzazioneRoutes from '@/router/specializzazione.js';
import newsRoutes from '@/router/notizie.js';
import eventRoutes from '@/router/eventi.js';
import partecipantiRoutes from '@/router/partecipanti.js';

Vue.use(Router);

let baseroutes = [
      {
         path: "/",
         component: BaseLayout,
         meta:{
            breadcrumb: {
              label:  "Home", 
            }      
         },
         children: [
            { 
               path: '/',
               name: "Home",
               meta:{
                  layout: Homepage,           
               }
            },            
         //   {
         //      path: '/argomenti/',
         //      meta:{
         //         layout: Search,
         //         breadcrumb() {
         //            return "Argomento";
         //         }
         //      },  
         //      children: [{
         //         path: ':slug',
         //         props: route => ({ filter: route.query.filter }),
         //         component: { template: '<h2>Context</h2>' },
         //         meta:{
         //            layout: Argumento,
         //            breadcrumb() {
         //               return this.$route.params.slug;
         //            }
         //         },        
         //      }]            
         //   },      

            { 
               path: '/dichiarazione-accessibilita',
               name: "Dichiarazione di accessibilità",
               component: Layout1,
               meta:{
                  breadcrumb() {
                      return `${this.$route.name}`;
                  }
               }          
            },   

            { 
               path: '/privacy-policy',
               name: "Privacy Policy",
               component: Layout1,
               params: true,
               props: true,
               meta:{
                  breadcrumb() {
                      return `${this.$route.name}`;
                  }
               }          
            },

            { 
               path: '/cookie-policy',
               name: "Cookie Policy",
               component: Layout1,
               params: true,
               props: true,
               meta:{
                  breadcrumb() {
                      return `${this.$route.name}`;
                  }
               }          
            },       

//            { 
//               path: '/cerca',
//               name: "Cerca",
//               component: Search,
//               meta:{
//                  params: true,
//                  props: true,
//                  breadcrumb() {
//                     return "Cerca";
//                  }      
//               },       
//               children: [{
//                  path: ':slug',
//                  props: route => ({ filter: route.query.filter }),
//                  component: { template: '<h2>Context</h2>' },
//                  meta:{
//                     layout: Argumento,
//                     breadcrumb() {
//                        return this.$route.params.slug;
//                     }
//                  },        
//               }]        
//            },
            { 
               path: '/cerca',
               name: "Cerca",
               component: Search2,
               meta:{
                  params: true,
                  props: true,
                  breadcrumb() {
                     return "Cerca";
                  }      
               },       
//                  breadcrumb() {
//                      return `${this.$route.name}`;
//                  }
//               }     
                
               children: [{
                  path: ':slug',
                  props: route => ({ filter: route.query.filter }),
                  component: { template: '<h2>Context</h2>' },
                  meta:{
                     layout: Argumento,
                     breadcrumb() {
                        return this.$route.params.slug;
                     }
                  },        
               }]        
            },            
            { 
               path: '/404',
               name: "NotFound",
               component: NotFound,
               meta:{
                  breadcrumb() {
                      return `${this.$route.name}`;
                  }
               }          
            },    
         ]       
      },        
      {
         path: '*',
         redirect: '/404'
      },
   ];

baseroutes   = baseroutes.concat(programmaRoutes);   
baseroutes   = baseroutes.concat(specializzazioneRoutes);   
baseroutes   = baseroutes.concat(partecipantiRoutes);
baseroutes   = baseroutes.concat(eventRoutes);
const routes = baseroutes.concat(newsRoutes);   
       
export default new Router({
   mode: 'history',
   //base: process.env.VUE_APP_URL,
   linkExactActiveClass: "active",
   routes,   
   scrollBehavior: to => {
      if (to.hash) {
         return {
            selector: to.hash,
            offset: {x:0, y:126},
            behavior: 'smooth'
         }
      }
   }
});
